import { SelectProps } from 'antd';
import { useMemo, VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { COMMODITY_CONFIG } from 'consts/commodities';
import { SelectMessages as messages } from './messages';
import { Select } from './Select';
import { getPrioritizedCommodity } from './utils/getPrioritizedCommodities';

export const CommoditySelect: VFC<SelectProps> = props => {
  const intl = useIntl();

  const options = useMemo(() => {
    const filteredCommodities = getPrioritizedCommodity();

    return filteredCommodities.map(type => ({
      label: intl.formatMessage(COMMODITY_CONFIG[type].message),
      value: type,
    }));
  }, [intl]);

  return (
    <Select
      className="w-100"
      options={options}
      placeholder={<FormattedMessage {...messages.commodityPlaceholder} />}
      {...props}
    />
  );
};
